export const cacheInformationKeys = ["apiCapabilities", "moduleAccess"];
const cacheDuration30Days = 1000 * 60 * 60 * 24 * 30;
export const cacheInformation = {
    apiCapabilities: {
        cacheKey: "api-capabilities",
        cacheDurationMs: cacheDuration30Days
    },
    moduleAccess: {
        cacheKey: "module-access",
        cacheDurationMs: cacheDuration30Days
    }
};
